(() => {
  const SOCIAL_GIFT_MARKER = 'hinoichiSocialGiftCheckoutActive';
  let pendingCheck;

  const cartUrl = (path) => `${window.Shopify?.routes?.root || '/'}${path}`;

  const isSocialGiftCart = (cart) => {
    if (String(cart?.attributes?._social_gift || '') === 'true') return true;

    return (cart?.items || []).some((item) =>
      String(item?.properties?._social_gift || '') === 'true'
    );
  };

  const inspectAndClear = async () => {
    const response = await fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('social_gift_cart_check_failed');

    const cart = await response.json();
    if (!isSocialGiftCart(cart)) {
      sessionStorage.removeItem(SOCIAL_GIFT_MARKER);
      return false;
    }

    const clearResponse = await fetch(cartUrl('cart/clear.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    });
    if (!clearResponse.ok) throw new Error('social_gift_cart_clear_failed');

    sessionStorage.removeItem(SOCIAL_GIFT_MARKER);
    return true;
  };

  const clearGiftCart = () => {
    if (!pendingCheck) {
      pendingCheck = inspectAndClear().finally(() => {
        pendingCheck = undefined;
      });
    }
    return pendingCheck;
  };

  window.SocialGiftCartGuard = {
    clearGiftCart,
    markCheckoutStarted: () => sessionStorage.setItem(SOCIAL_GIFT_MARKER, 'true'),
  };

  window.addEventListener('pageshow', () => {
    if (sessionStorage.getItem(SOCIAL_GIFT_MARKER) === 'true') {
      clearGiftCart().catch(() => {});
    }
  });
})();
